var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-view main-layout"},[_c('section',{staticClass:"route-view"},[_c('el-container',[(!_vm.isCollapse)?_c('left-menu'):_vm._e(),_c('el-container',[_c('top-header'),_c('el-main',[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }